import { useTranslation } from "react-i18next";
import { Box } from "@mantine/core";
import { useGetInspections } from "@/services/Inspections";
import { SubHeader } from "@/components/molecules/SubHeader";
import InspectionsFilter from "@/components/organisms/InspectionsTable/InspectionsFilter";
import InspectionsTable from "@/components/organisms/InspectionsTable";
import styles from "./styles.module.css";

/** Receiving inspection queue: the company's deliveries waiting to be inspected. */
export default function Inspections() {
  const { t } = useTranslation();
  // Unfiltered, so the count doesn't change with the filters.
  const { data: inspections } = useGetInspections({});

  return (
    <>
      <title>{`Reviver - ${t("navigation:inspections")}`}</title>
      <meta name="description" content={`Reviver - ${t("navigation:inspections")}`} />
      <SubHeader
        title={t("navigation:inspections")}
        count={inspections?.length}
        countLabel={t("enumerables:orderStatus.AWAITING_INSPECTION")}
      />
      <Box className={styles.contentRoot}>
        <div className={styles.contentInner}>
          <InspectionsFilter />
          <InspectionsTable />
        </div>
      </Box>
    </>
  );
}
